import * as React from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowBack } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useAppDispatch } from 'src/hooks/redux';
import { sendForgotRequest } from 'src/store/reducers/passwordRestorationSlice';
import { isEmail } from 'src/utils/validation';

import { EmailInput } from '../../components';
import { SuccessModal } from '../../components/Modal/SuccessModal';

export const ResetPasswordScreen = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate();

  const [emailInput, setEmailInput] = useState('');
  const [isEmailSentSuccess, setIsEmailSentSuccess] = useState(false);

  const onEmailInputValidate = (value: string) => {
    if (!isEmail(value)) {
      return 'The value is not a valid email address';
    }
    return '';
  }

  const handleSubmit = () => {
    dispatch(sendForgotRequest({login: emailInput}))
    setIsEmailSentSuccess(true)
  };

  return (
    <Box display="flex">
      {
        isEmailSentSuccess
          ? (
            <SuccessModal
              successText="We have sent a password reset link to your email "
              okButtonTitle="Ok, got it"
              onButtonClick={() => {
                navigate('/');
              }}/>
          )
          : (
            <Box sx={{
              borderRadius: 4,
              paddingX: 4,
              maxWidth: 494,
              backgroundColor: 'white',
            }}>
              <Box
                sx={{
                  marginTop: '40px',
                  display: 'flex',
                  flexDirection: 'column',
                  textAlign: 'center',
                }}
              >
                <Box sx={{
                  display: 'flex',
                  position: 'relative',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  flex: 1,
                }}>
                  <IconButton
                    onClick={() => {
                      navigate(-1);
                    }}
                    sx={{
                      width: '40px',
                      height: '40px',
                      borderRadius: '6px',
                      backgroundColor: '#F3F3F3',
                      color: '#828282',
                      fontSize: '26px',
                      position: 'absolute',
                      top: '-8px'
                    }}
                    disableRipple>
                    <ArrowBack/>
                  </IconButton>
                  <Box sx={{
                    mb: 4
                  }}>
                    <img
                      alt="Logo"
                      width="40px"
                      src="/images/logo.png"
                    />
                  </Box>
                </Box>
                <Box sx={{
                  mb: 4
                }}>
                  <Typography component="h1" variant="h2">
                    Reset password
                  </Typography>
                  <Typography sx={{
                    color: '#363636',
                    fontSize: '16px',
                    fontWeight: '400',
                    marginTop: '40px',
                    textAlign: 'left',
                  }}>
                    Forgot password? Please enter email address assosiated with your account. You will recieve a link to create new password via email.
                  </Typography>
                </Box>
                <Box>
                  <EmailInput
                    label="Email"
                    id="email-input"
                    name="email"
                    initialValue={emailInput}
                    onChange={setEmailInput}
                    validationFn={onEmailInputValidate}
                  />
                  <Button
                    onClick={handleSubmit}
                    fullWidth
                    size="large"
                    disabled={!isEmail(emailInput)}
                    disableRipple
                    disableElevation
                    variant="contained"
                    sx={{mt: 3, mb: 4}}
                  >
                    Reset password
                  </Button>
                </Box>
              </Box>
            </Box>
          )
      }
    </Box>
  );
};
